import { createClient } from '@sanity/client';

export const client = createClient({
  projectId: 'dtgm1l01',  // Your project ID from sanity.config.ts
  dataset: 'production',
  useCdn: true, // Set to `false` for draft content
  apiVersion: '2023-05-03', // Use a UTC date string
});

export const fetchProjects = async () => {
  const projects = await client.fetch(`*[_type == "project"] | order(order asc) {
    _id,
    title,
    slug,
    description,
    tags,
    "image": image.asset->url,
    projectLink,
    githubLink,
    featured
  }`);
  return projects;
};

// Helper function to format date display for education and experience
export const formatDate = (date) => {
  if (!date) return 'Present';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};